// extracted by mini-css-extract-plugin
export default {"headerWrapper":"QHHKqlVnSZi4Iz_vuZbd"};